// extracted by mini-css-extract-plugin
export default {"accountLinkButton":"accountLink_accountLinkButton__-nX7e","buttonColor":"accountLink_buttonColor__4aT5n"};